import { IDebt, PixInfo } from "../context/Payments";
import { apiLambda } from "./apiLambda";

interface IData {
    name: string;
    cnpj: string;
    pix: PixInfo;
    cupom: string;
    email: string;
    phone: string;
    ipvaSelected: IDebt[];
    licenciamentoSelected: IDebt[];
    dpvatSelected: IDebt[];
    multasSelected: IDebt[];
    outrosSelected: IDebt[];
    consultCode: number;
    sub: string;
}

// {
//     sucesso: boolean;
//     mensagem: string;
//     qrCode: string;
//     copiaCola: string;
//     validade: string;
// }

export default async function generatePix(
    data: IData,
) {
    try {
        const {
            name,
            cnpj,
            pix,
            cupom,
            email,
            phone,
            ipvaSelected,
            licenciamentoSelected,
            dpvatSelected,
            multasSelected,
            outrosSelected,
            consultCode,
            sub
        } = data;

        const debitos: { codigo: number; valor: number }[] = [];

        if (ipvaSelected.length) {
            ipvaSelected.map((i: IDebt) => {
                const debito = {
                    codigo: i.codigo,
                    valor: i.valor
                };
                debitos.push(debito);
            });
        }

        if (licenciamentoSelected.length) {
            licenciamentoSelected.map((i: IDebt) => {
                const debito = {
                    codigo: i.codigo,
                    valor: i.valor
                };
                debitos.push(debito);
            });
        }

        if (dpvatSelected.length) {
            dpvatSelected.map((i: IDebt) => {
                const debito = {
                    codigo: i.codigo,
                    valor: i.valor
                };
                debitos.push(debito);
            });
        }

        if (multasSelected.length) {
            multasSelected.map((i: IDebt) => {
                const debito = {
                    codigo: i.codigo,
                    valor: i.valor
                };
                debitos.push(debito);
            });
        }

        if (outrosSelected.length) {
            outrosSelected.map((i: IDebt) => {
                const debito = {
                    codigo: i.codigo,
                    valor: i.valor
                };
                debitos.push(debito);
            });
        }

        const body = {
            payloadCaptura: {
                parcelas: pix.month,
                valor: pix.totalPrice,
                cupom: cupom,
                debitos: debitos,
                pix: [
                    {
                        pagador: {
                            nome: name,
                            cpf: cnpj.replace(/\D/g, ''),
                            email: email,
                            telefone: phone.replace(/\D/g, '')
                        },
                        valor: pix.totalPrice
                    }
                ],
                comportamento: {
                    konduto: sub,
                    clearsale: '',
                    analytics: ''
                }
            }
        };

        const payment = await apiLambda.post(`comunix/payment/pix/${consultCode}`, body);

        return payment.data.data;
    } catch (err: any) {
        console.log('GeneratePix ====> ', err?.response?.status ?? err?.message);
        if (err.response?.data?.warning) {
            return { sucesso: false, warning: err.response.data.warning };
        }
        return { sucesso: false, data: err.response?.data?.data };
    }
}
